import { LoadableRoute } from 'routes/utils/loadable';

export const SalesforceAuthModal = LoadableRoute({
  loader: () =>
    import(
      /* webpackChunkName: "IntegrationSalesforceAuthModal" */ './SalesforceAuthModal'
    ),
});
